import AttentionBar from '../Page/AttentionBarPicker';

export default AttentionBar;
